<template>
  <div class="aCustomInput field">
    <label  :for="fieldname"><span v-html="labelSpaced"></span>&nbsp;<span v-if="isRequired" class="req" tabindex="-1">*</span></label>
    
    <div class="inputwrapper">
      <VueDatePicker
      :type="inputType"
      v-model="modelValueComputed"
      :class="{hasError: isInError, hasSuccess: isInSuccess, isLoading: isLoading}"
      class="datePickerInput"
      format="dd/MM/yyyy"
      :locale="$i18n.locale.slice(0,2)"
      :cancelText="$t('inputsTexts.datepicker.cancel')" 
      :selectText="$t('inputsTexts.datepicker.select')"
      :aria-label="label"
      tabindex="0"

      >
    </VueDatePicker>
  </div>
  
  <div class="errorMessage" v-if="isInError" tabindex="0"><ul v-html="errorMessage"></ul></div>
  <div class="helper" :class="fieldname + '-helper'" v-html="helper" role="note" :aria-label="helper"></div>
</div>
</template>

<!-- ========================================= -->

<script>
// Load only a part of lodash to keep the application small
  import {debounce} from "lodash";
  import FormFields from "../mixins/FormFields";
  import config from "../config";

  import { customLog } from "../js/customlog.js";
  const log = (str, type) => { 
    if ( config.isAdminNavAllowed ){ customLog(str, type); }
  }; 

  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css'

  export default {
    name: "customDatePicker",

    emit: ["update:modelValue", "update:valueHasChanged", "runCheck", "maintenanceDetected"],

    mixins: [FormFields],

    components: {
      VueDatePicker,
    },

    props: {
      inputType: {
        type: String,
        validator: function (value) {
          return ["text", "password", "email", "hidden", "number", "search", "tel", "url", "date"].includes(value);
        }
      },
      label: {
        type: String,
        required: true
      },
      isDisabled: {
        type: Boolean,
        required: false,
        default: false
      },
      valueHasChanged: {
        type: String,
        required: false
      },
      ariaLabel: {
        type: String,
        required: false,
        default: ''
      },
    },

    data() {
      return {
        errorMessage: "",
        config: config,
        date: null,
      }
    },

    computed: {

      modelValueComputed: {
        get() {
          return this.modelValue;
        },
        set(newVal) {
          this.validateMyselfDebounced();
          if(newVal!== null){
            this.$emit('update:modelValue', newVal.toISOString().substring(0, 10));
          }else{
            this.$emit('update:modelValue', newVal);
          }
        }
      },

    },

    methods: {
      validateMyself() {
        this.setLoading();
        let data = {
          [this.fieldname]: this.modelValueComputed
        };

        this.axios.post(
      `/lead/${config.idlead}/data/${this.fieldname}/validate`,
      data
      )
        .then(() => {

            /* If the value is an integer / if it's a string */
          if (typeof this.modelValueComputed == "number" && this.modelValueComputed > 0 || typeof this.modelValueComputed == "string" && this.modelValueComputed.length > 0) {
            this.giveSuccess();
            this.$emit('runCheck', {fieldname: this.fieldname, valid: true});
          } else {
            this.removeSuccessOrError();
          }
          this.setNotLoading();
        })
        .catch(error => {
          if (error.response.status === 503) {
            this.setNotLoading();
            this.$emit('maintenanceDetected');
          } else {
              // Error managing. Get Values, whatever keys are
            this.errorMessage = this.$t('errors.unmanaged');
            try {
              if (error.response.data.errors) {
                let combinedList = Object.values(error.response.data.errors).flat();
                this.errorMessage = this.createAnHtmlListFromErrors(combinedList);
              }
            } catch (e) {
              log('An error occured');
            }
            this.giveError();
            this.setNotLoading();
            this.$emit('runCheck', {fieldname: this.fieldname, valid: false});
          }

        })
        .then(() => {
        });
      },

      createAnHtmlListFromErrors(errorsList) {
        let html = "";
        errorsList.forEach(err => {
          html += `<li>${err}</li>`;
        });
        return html;
      },

      addIdToInput(){
        let el = document.getElementsByClassName("dp__input");
        el[0].setAttribute('id',this.fieldname);
      },

    },

    watch: {
      modelValue() {
        this.validateMyselfDebounced();
      },
    },

    created() {
      this.validateMyselfDebounced = debounce(this.validateMyself, 500);
    // run validation immediately when the value is not null or empty
      if (this.modelValueComputed) {
        this.validateMyselfDebounced();
      }

    },

    mounted(){
      this.addIdToInput();
    }

  }

</script>

<!-- ========================================= -->

<style lang="scss" scoped>
</style>
